import * as u from "react";
import { useUtils as f } from "./useUtils.mjs";
function d(n, {
  disableFuture: o,
  maxDate: e,
  timezone: s
}) {
  const t = f();
  return u.useMemo(() => {
    const r = t.dateWithTimezone(void 0, s), i = t.startOfMonth(o && t.isBefore(r, e) ? r : e);
    return !t.isAfter(i, n);
  }, [o, e, n, t, s]);
}
function M(n, {
  disablePast: o,
  minDate: e,
  timezone: s
}) {
  const t = f();
  return u.useMemo(() => {
    const r = t.dateWithTimezone(void 0, s), i = t.startOfMonth(o && t.isAfter(r, e) ? r : e);
    return !t.isBefore(i, n);
  }, [o, e, n, t, s]);
}
export {
  d as useNextMonthDisabled,
  M as usePreviousMonthDisabled
};
//# sourceMappingURL=date-helpers-hooks.mjs.map
